import { render, staticRenderFns } from "./ProgressTable.vue?vue&type=template&id=63017038&"
import script from "./ProgressTable.vue?vue&type=script&lang=js&"
export * from "./ProgressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports